import DateRangeIcon from '@mui/icons-material/DateRange';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import TimelapseIcon from '@mui/icons-material/Timelapse';
import DataSaverOnIcon from '@mui/icons-material/DataSaverOn';
import ChatIcon from '@mui/icons-material/Chat';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import ApprovalIcon from '@mui/icons-material/Approval';
import PeopleIcon from '@mui/icons-material/People';
import HandshakeIcon from '@mui/icons-material/Handshake';

export interface NavigationItem {
    label: string;
    icon: JSX.Element;
    path?: string;
    onClick?: () => void;
    testId?: string;
    id?: string;
    new?: boolean;
}

export interface NavigationConfig {
    main: NavigationItem[];
    pay: NavigationItem[];
    collect: NavigationItem[];
    settings: NavigationItem[];
    other: NavigationItem[];
}

// Centralized navigation configuration
export const navigationConfig: NavigationConfig = {
    main: [
        {
            label: 'Wallet',
            path: '/wallet',
            icon: <AccountBalanceWalletIcon />,
            testId: 'wallet',
        },
        {
            label: 'Approvals',
            path: '/my-approvals',
            icon: <ApprovalIcon />,
            testId: 'my-approvals',
        },
        {
            label: 'Reports',
            path: '/reports',
            icon: <AnalyticsIcon />,
            testId: 'reports',
        },
        {
            label: 'Activity Center',
            path: '/activity-center',
            icon: <DateRangeIcon />,
            testId: 'activity-center',
        },
    ],
    pay: [
        {
            label: 'PayLater',
            path: '/paylater',
            icon: <TimelapseIcon />,
            testId: 'paylater',
        },
        {
            label: 'DrawDown',
            path: '/drawdown',
            icon: <DataSaverOnIcon />,
            testId: 'drawdown',
        },
    ],
    collect: [
        {
            label: 'FundNow',
            path: '/fundnow',
            icon: <MonetizationOnIcon />,
            testId: 'fundnow',
        },
        {
            label: 'OfferTerms',
            path: '/offerterms',
            icon: <HandshakeIcon />,
            testId: 'offerterms',
            new: true,
        },
    ],
    settings: [
        {
            label: 'Account',
            path: '/account',
            icon: <AdminPanelSettingsIcon />,
            testId: 'account',
        },
        {
            label: 'Team Members',
            path: '/members',
            icon: <PeopleIcon />,
            testId: 'members',
        },
        {
            label: 'File Upload',
            path: '/file-upload',
            icon: <Inventory2Icon />,
            testId: 'files',
        },
        {
            label: 'Integrations',
            path: '/integrations',
            icon: <SyncAltIcon />,
            testId: 'integrations',
        },
    ],
    other: [
        {
            label: 'Chat',
            icon: <ChatIcon />,
            onClick: () => window?.HubSpotConversations?.widget.open(),
        },
    ],
};

// Create route-to-name mapping from the navigation config
export const createRouteMapping = (): Record<string, string> => {
    const mapping: Record<string, string> = {};

    Object.values(navigationConfig)
        .flat()
        .forEach(item => {
            if (item.path) {
                mapping[item.path] = item.label;
            }
        });

    return mapping;
};
